<template>
  <div>
    <div class="content-box">
      <div class="row element-box">
        <div class="col-sm-5">
          <div class="element-info">
            <div class="element-info-with-icon">
              <div style="text-align: left">
                <router-link
                  class="btn btn-sm btn-outline-dark"
                  :to="{ name: 'af-activos', params: {} }"
                >
                  <i class="fas fa-chevron-left"></i>
                  Regresar
                </router-link>
              </div>
              <div class="element-info-text">
                <br />
                <div class="element-inner-header col-12">
                  <span style="font-size: 20px" class="font-weight-bold text-success"
                    >Activo Fijo</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="user-profile compact">
            <div class="up-head-w">
              <div class="up-main-info">
                <h2 class="up-header" style="text-shadow: 5px 5px 5px rgb(0, 0, 0)">
                  {{ current.nombre }}
                </h2>
                <h6 class="up-sub-header" style="text-shadow: 5px 5px 5px black">
                  {{ current.descripcion }}
                </h6>
                <form action="">
                  <input
                    type="file"
                    id="file"
                    style="display: none"
                    ref="file"
                    v-if="current.id"
                    v-on:change="handleFileUpload()"
                  />
                  <button
                    v-if="file == '' && current.id"
                    class="btn btn-info btn-sm"
                    type="button"
                    @click="cambiarfoto"
                  >
                    <i class="os-icon os-icon-image"></i>
                    <span>Cambiar Foto</span>
                  </button>
                  <button
                    v-if="file != ''"
                    class="btn btn-danger btn-sm"
                    type="button"
                    @click="cancelarFoto"
                  >
                    <i class="os-icon os-icon-close"></i>
                    <span>Cancelar</span>
                  </button>
                  <button
                    v-if="file != ''"
                    class="btn btn-success btn-sm"
                    type="button"
                    @click="submitFile"
                  >
                    <i class="os-icon os-icon-image"></i>
                    <span>Subir</span>
                  </button>
                </form>
              </div>
              <img
                class="decor"
                style="width: 100%; height: 100%; object-fit: cover"
                version="1.1"
                :src="current.imagen"
              />
            </div>
            IDENTIFICADOR: &nbsp;
            <span class="font-weight-bold text-success" style="font-size: 15px">{{
              current.identificador
            }}</span
            ><br />
            BARRA GS1: &nbsp;
            <span class="font-weight-bold text-success" style="font-size: 15px">{{
              current.barra_gs1
            }}</span>
            <div>
              <br />
              <div class="row">
                <div class="col-12">
                  <label
                    v-bind:class="{
                      'text-danger': current.errors && current.errors.nombre,
                    }"
                    >Nombre de activo</label
                  >
                  <input
                    v-model="current.nombre"
                    class="form-control"
                    autofocus="autofocus"
                    placeholder="Nombre"
                    type="text"
                    v-bind:class="{
                      'is-invalid': current.errors && current.errors.nombre,
                    }"
                  />
                  <small
                    v-if="current.errors && current.errors.nombre"
                    class="form-text text-danger"
                    >{{ current.errors.nombre[0] }}</small
                  >
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger': current.errors && current.errors.fecha_compra,
                      }"
                      >Fecha Compra</label
                    >
                    <input
                      v-model="current.fecha_compra"
                      class="form-control"
                      placeholder="Fecha"
                      type="date"
                      v-bind:class="{
                        'is-invalid': current.errors && current.errors.fecha_compra,
                      }"
                    />
                    <small
                      v-if="current.errors && current.errors.fecha_compra"
                      class="form-text text-danger"
                      >{{ current.errors.fecha_compra }}</small
                    >
                  </div>
                </div>
                <div class="col-6">
                  <TiendaSelectComponent :desblock="true" :current="current" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-7">
          <div class="element-wrapper">
            <div>
              <div>
                <div class="dropdown show" style="text-align: right">
                  <button
                    class="btn btn-secondary dropdown-toggle"
                    href="#"
                    role="button"
                    id="dropdownMenuLink"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="fa fa-bars"></i> Acciones
                  </button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                    <a class="dropdown-item" @click="Imprimir(current.id)">
                      Imprimir Barra <i class="fas fa-barcode"></i>
                    </a>
                    <a @click="duplicar()" class="dropdown-item">
                      Duplicar Transacción <i class="fas fa-copy"></i>
                    </a>
                  </div>
                </div>
              </div>
              <form>
                <div class="row">
                  <div class="col-12">
                    <label
                      v-bind:class="{
                        'text-danger': current.errors && current.errors.descripcion,
                      }"
                      >Descripción</label
                    >
                    <textarea
                      class="form-control"
                      rows="2"
                      v-model="current.descripcion"
                      autofocus="autofocus"
                      placeholder="Descripción"
                      v-bind:class="{
                        'is-invalid': current.errors && current.errors.descripcion,
                      }"
                    >
                    </textarea>
                    <small
                      v-if="current.errors && current.errors.descripcion"
                      class="form-text text-danger"
                      >{{ current.errors.descripcion[0] }}</small
                    >
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger': current.errors && current.errors.marca,
                        }"
                        >Marca</label
                      >
                      <select
                        class="form-control"
                        v-model="current.marca"
                        placeholder="Marcas"
                        type="text"
                        v-bind:class="{
                          'is-invalid': current.errors && current.errors.marca,
                        }"
                      >
                        <option v-for="d in marcas" :key="d.id" :value="d.id">
                          {{ d.nombre }} - {{ d.descripcion }}
                        </option>
                      </select>
                      <small
                        v-if="current.errors && current.errors.marca"
                        class="form-text text-danger"
                        >{{ current.errors.marca[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger': current.errors && current.errors.color,
                        }"
                        >Color</label
                      >
                      <select
                        :style="{ 'background-color': current.color }"
                        v-bind:style="
                          current.color == 'white' ||
                          current.color == 'beige' ||
                          current.color == 'turquoise' ||
                          current.color == 'gold' ||
                          current.color == 'MediumSpringGreen' ||
                          current.color == 'LightSkyBlue' ||
                          current.color == 'pink' ||
                          current.color == 'Aqua' ||
                          current.color == 'yellow' ||
                          current.color == null ||
                          current.color == ''
                            ? 'color: black;'
                            : 'color: white;'
                        "
                        style="font-weight: bold"
                        class="form-control rounded bright"
                        v-model="current.color"
                      >
                        <option value="black">Negro</option>
                        <option value="white">Blanco</option>
                        <option value="silver">Plateado</option>
                        <option value="gray">Gris</option>
                        <option value="red">Rojo</option>
                        <option value="blue">Azul</option>
                        <option value="green">Verde</option>
                        <option value="Olive">Olivo</option>
                        <option value="yellow">Amarillo</option>
                        <option value="orange">Anaranjado</option>
                        <option value="brown">Café</option>
                        <option value="purple">Morado</option>
                        <option value="MediumPurple">Violeta</option>
                        <option value="pink">Rosado</option>
                        <option value="gold">Dorado</option>
                        <option value="turquoise">Turquesa</option>
                        <option value="LightSkyBlue">Celeste</option>
                        <option value="beige">Beige</option>
                        <option value="navy">Azul Marino</option>
                        <option value="MediumSpringGreen">Menta</option>
                        <option value="darkred">Rojo Oscuro</option>
                        <option value="Aqua">Aqua</option>
                        <option value="fuchsia">Fucsia</option>
                      </select>
                      <small
                        v-if="current.errors && current.errors.color"
                        class="form-text text-danger"
                        >{{ current.errors.color }}</small
                      >
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger': current.errors && current.errors.tipo_vehiculo,
                        }"
                        >Tipo Vehiculo</label
                      >
                      <select
                        class="form-control"
                        v-model="current.tipo_vehiculo"
                        placeholder="Tipo Vehiculo"
                        type="text"
                        v-bind:class="{
                          'is-invalid': current.errors && current.errors.tipo_vehiculo,
                        }"
                      >
                        <option value="PI">PICKUP</option>
                        <option value="S">SEDAN</option>
                        <option value="PA">PANEL</option>
                        <option value="C">CAMION</option>
                        <option value="M">MOTOCICLETA</option>
                      </select>
                      <small
                        v-if="current.errors && current.errors.tipo_vehiculo"
                        class="form-text text-danger"
                        >{{ current.errors.tipo_vehiculo }}</small
                      >
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger': current.errors && current.errors.estado,
                        }"
                        >Estado</label
                      >
                      <select
                        class="form-control"
                        v-model="current.estado"
                        placeholder="Estado"
                        type="text"
                        v-bind:class="{
                          'is-invalid': current.errors && current.errors.estado,
                        }"
                      >
                        <option value="E">EXCELENTE</option>
                        <option value="B">BUEN ESTADO</option>
                        <option value="M">MAL ESTADO</option>
                        <option value="9">DE BAJA</option>
                      </select>
                      <small
                        v-if="current.errors && current.errors.estado"
                        class="form-text text-danger"
                        >{{ current.errors.estado[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-6">
                    <GrupoActivoComponent :desblock="true" :current="current" />
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger': current.errors && current.errors.modelo,
                        }"
                        >Modelo</label
                      >
                      <input
                        v-model="current.modelo"
                        class="form-control"
                        placeholder="Modelo"
                        type="text"
                        v-bind:class="{
                          'is-invalid': current.errors && current.errors.modelo,
                        }"
                      />
                      <small
                        v-if="current.errors && current.errors.modelo"
                        class="form-text text-danger"
                        >{{ current.errors.modelo }}</small
                      >
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger': current.errors && current.errors.vida_util,
                        }"
                        >Vida Util (Años)</label
                      >
                      <input
                        v-model="current.vida_util"
                        class="form-control"
                        placeholder="# años"
                        type="number"
                        v-bind:class="{
                          'is-invalid': current.errors && current.errors.vida_util,
                        }"
                      />
                      <small
                        v-if="current.errors && current.errors.vida_util"
                        class="form-text text-danger"
                        >{{ current.errors.vida_util }}</small
                      >
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger': current.errors && current.errors.precio_compra,
                        }"
                        >Precio Compra</label
                      >
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <div class="input-group-text">Q</div>
                        </div>
                        <input
                          class="form-control text-right"
                          v-model="current.precio_compra"
                          placeholder="Precio de compra"
                          type="text"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger': current.errors && current.errors.no_fact_compra,
                        }"
                        ># Factura Compra</label
                      >
                      <input
                        v-model="current.no_fact_compra"
                        class="form-control"
                        placeholder="# Factura"
                        type="text"
                        v-bind:class="{
                          'is-invalid': current.errors && current.errors.no_fact_compra,
                        }"
                      />
                      <small
                        v-if="current.errors && current.errors.no_fact_compra"
                        class="form-text text-danger"
                        >{{ current.errors.no_fact_compra }}</small
                      >
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger': current.errors && current.errors.placa,
                        }"
                        >Placa o S/N</label
                      >
                      <input
                        v-model="current.placa"
                        class="form-control"
                        placeholder="# Placa"
                        type="text"
                        v-bind:class="{
                          'is-invalid': current.errors && current.errors.placa,
                        }"
                      />
                      <small
                        v-if="current.errors && current.errors.placa"
                        class="form-text text-danger"
                        >{{ current.errors.placa }}</small
                      >
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger': current.errors && current.errors.mac_adress,
                        }"
                        >Dirección MAC</label
                      >
                      <input
                        v-model="current.mac_adress"
                        class="form-control"
                        placeholder="Mac Adress"
                        type="text"
                        v-bind:class="{
                          'is-invalid': current.errors && current.errors.mac_adress,
                        }"
                      />
                      <small
                        v-if="current.errors && current.errors.mac_adress"
                        class="form-text text-danger"
                        >{{ current.errors.mac_adress }}</small
                      >
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-4">
          <button class="btn btn-primary" type="button" @click="guardar">
            Guardar <i class="fa fa-save"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import GrupoActivoComponent from "@/components/commons/GrupoActivoComponent";

export default {
  components: { TiendaSelectComponent, GrupoActivoComponent },
  data() {
    return {
      marcas: [],
      file: "",
      current: {
        fecha_compra: "",
        marca: "",
        precio_compra: 0,
        tipo_vehiculo: "",
        no_fact_compra: "",
        modelo: "",
        mac_adress: "",
        mac_adress: "",
        placa: "",
        estado: "",
        color: "",
        errors: [],
      },
      errors: [],
      data: [],
      grupos: [],
    };
  },

  computed: {},
  mounted() {
    let self = this;
    self.refreshMarca();
    if (this.$route.params.id) {
      self.refreshData();
    }
  },
  methods: {
    duplicar() {
      let self = this;
      Notifications.alert.confirm(
        "Duplicar información de activo",
        "¿Esta seguro?",
        "",
        function () {
          DynamicService.getAction(
            "af",
            "activo",
            self.current.id,
            "duplicar_activo"
          ).then((response) => {
            self.$router.push({
              name: "af-activos-editar",
              params: { id: response.data.id },
            });
            self.refreshData();
            Notifications.alert.success(
              "Duplicar activo",
              "Realizado satisfactoriamente, por favor actualizar los datos individuales de cada activo"
            );
          });
        }
      );
    },
    refreshMarca() {
      let self = this;
      DynamicService.fetch("af", "marca", {
        quitar_paginacion: true,
      }).then((res) => {
        self.marcas = res.data;
      });
    },
    cambiarfoto() {
      this.$refs.file.click();
    },
    cancelarFoto() {
      this.file = "";
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    submitFile() {
      let self = this;
      if (self.current.fecha_compra) {
        self.current.fecha_compra = moment(self.current.fecha_compra).format(
          "YYYY/MM/DD"
        );
      }
      if (self.current.fecha_compra == null) {
        self.current.fecha_compra = "";
      }
      if (self.current.precio_compra == null) {
        self.current.precio_compra = 0;
      }
      if (self.current.tipo_vehiculo == null) {
        self.current.tipo_vehiculo = "";
      }
      if (self.current.marca == null) {
        self.current.marca = "";
      }
      DynamicService.saveImage("af", "activo", self.current, self.file)
        .then((res) => {
          self.current = res.data;
          self.current.pk = self.current.id;
          Notifications.alert.success("Activo Fijo", "Se ha guardado la Información.");
          self.file = "";
          self.$router.push({
            name: "af-activos-editar",
            params: { id: self.current.id },
          });
        })
        .catch((error) => {
          self.file = "";
          self.current.errors = Object.assign(self.current.errors, error.response.data);
          if ("detail" in error.response.data) {
            Notifications.alert.error("Error", error.response.data.detail);
          }
        });
    },
    guardar() {
      let self = this;
      if (
        self.current.fecha_compra &&
        self.current.fecha_compra != null &&
        self.current.fecha_compra != ""
      ) {
        self.current.fecha_compra = moment(self.current.fecha_compra).format(
          "DD/MM/YYYY"
        );
      } else {
        self.current.fecha_compra = null;
      }
      delete self.current.imagen;
      DynamicService.save("af", "activo", self.current)
        .then((res) => {
          Notifications.alert.success("Activo Fijo", "Se ha guardado la Información.");
          self.current.errors = [];
          self.$router.push({
            name: "af-activos-editar",
            params: { id: res.data.id },
          });
          self.refreshData();
        })
        .catch((error) => {
          self.current.errors = error.response.data;
          if ("detail" in error.response.data) {
            Notifications.alert.error("Error", error.response.data.detail);
          }
        });
    },
    refreshData() {
      let self = this;
      DynamicService.getById("af", "activo", this.$route.params.id).then((response) => {
        self.current = response.data;
        console.log(self.current.fecha_compra);
        if (self.current.fecha_compra) {
          self.current.fecha_compra = moment(
            self.current.fecha_compra,
            "DD/MM/YYYY"
          ).format("YYYY-MM-DD");
        }
        self.current.pk = self.current.id;
      });
    },
    Imprimir(det) {
      det = det.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=catalogos/Barra_activos.jrxml&id=${det}`
      );
    },
  },
};
</script>
